import {
  Box,
  Card,
  Checkbox,
  Dialog,
  FormControl,
  InputLabel,
  MenuItem,
  Button as MUIButton,
  Select,
  Tooltip,
  Typography,
} from '@mui/material';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import dayjs from 'dayjs';
import { ReactElement, useState } from 'react';
import {
  BulkDeleteButton,
  CreateButton,
  Datagrid,
  EditButton,
  Filter,
  FunctionField,
  List,
  TextField,
  NumberField,
  TopToolbar,
  useListController,
  useTranslate,
  DeleteButton,
  SelectField,
  TextInput,
  SelectInput,
} from 'react-admin';
import { CustomBreadcrumbs } from '../../../../../components/custom-breadcrumbs';
import { DashboardContent } from '../../../../../layouts/dashboard';
import { Resources } from '../../resource';
import { PermissionGuard } from 'src/routes/components/permission-guard';
import ErrorPage403 from 'src/pages/error/403';
import { PermissionButton } from 'src/routes/components/permission-button';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import AddressField from 'src/pages/admin/components/AddressField';
// import CreateMetadata from './Create';
// import EditMetadata from './Edit';
import FilterGroup from 'src/pages/admin/components/FilterGroup';
import XTextInput from 'src/pages/admin/components/XTextInput';
import { chains } from 'src/assets/data';

const ListFilter = (props: any) => {
  // const { filterValues } = useListController();

  return (
    <Filter {...(props || {})}>
      {/* <FilterGroup alwaysOn spacing={0} p={0}>
        <FilterGroup>
          <TextInput source="address" label="module.tokenMetadata.address" />
          <SelectInput
              source="chainId"
              helperText={<span style={{ color: 'red' }}></span>}
              choices={[
                  { id: 501424, name: 'SOLANA' },
                  { id: 1, name: 'ETH' }
              ]}
          />
        </FilterGroup>
      </FilterGroup> */}
    </Filter>
  );
};

const View = () => {
  const [popup, setPopup] = useState<ReactElement>();
  const translate = useTranslate();

  return (
    <DashboardContent>
      <PermissionGuard resource="swap-routing-statistics" action="read" fallback={<ErrorPage403 />}>
        <CustomBreadcrumbs
          heading={translate('resource.routingStatistics')}
          links={[
            { name: translate('resource.transaction'), href: '#' },
            {
              name: translate('resource.routingStatistics'),
              href: `/${Resources.routingStatistics}`,
            },
            { name: translate('resource.list') },
          ]}
          // action={
          //   <PermissionGuard resource="swap-routing-statistics" action="create" fallback={<></>}>
          //     <CreateButton variant="contained" size='medium' onClick={(e)=> {
          //       e.preventDefault()
          //       setPopup(<CreateMetadata onClose={() => setPopup(undefined)} />)
          //     }} />
          //   </PermissionGuard>
          // }
        />

        <Card sx={{ mt: 3, pb: 2 }}>
          <List
            actions={false}
            empty={false}
            // filters={<ListFilter />}
            perPage={10}
            exporter={false}
          >
            <Box sx={{ overflow: 'auto' }}>
              <Datagrid
                rowClick={false}
                // bulkActionButtons={
                //   <PermissionButton resource="swap-routing-statistics" action="delete">
                //     <BulkDeleteButton />
                //   </PermissionButton>
                // }
                sx={{
                  '.RaBulkActionsToolbar-toolbar': {
                    position: 'relative !important',
                    transform: 'none !important',
                  },
                }}
              >
                <TextField source="type" label="module.routingStatistics.type" sortable={false} />
                <NumberField
                  source="totalSwapUsd"
                  label="module.routingStatistics.totalSwapUsd"
                  sortable={false}
                />
                <NumberField
                  source="usageCount"
                  label="module.routingStatistics.usageCount"
                  sortable={false}
                />
              </Datagrid>
            </Box>
          </List>
        </Card>
        <Dialog open={Boolean(popup)} onClose={() => setPopup(undefined)} maxWidth="md" fullWidth>
          {popup}
        </Dialog>
      </PermissionGuard>
    </DashboardContent>
  );
};

export default View;
